/**
 * Admin-only route guard.
 *
 * Restricts access to routes that require admin role.
 * Redirects non-admin users to the invoices page.
 */

import { Navigate, Outlet } from 'react-router-dom';

import { useAuth } from '@/hooks/useAuth';

/**
 * Route guard that only allows admin users.
 * Non-admin users are redirected to the invoices page.
 *
 * @example
 * ```tsx
 * // In router config
 * {
 *   element: <AdminOnlyRoute />,
 *   children: [
 *     { path: 'users', element: <UsersPage /> },
 *   ],
 * }
 * ```
 */
export function AdminOnlyRoute() {
  const { user } = useAuth();

  if (user?.role !== 'admin') {
    return <Navigate to="/webadmin/app/invoices" replace />;
  }

  return <Outlet />;
}
